import {
  GetAllCatalogProductGridItemsQuery,
  GetCurationCatalogProductsQuery,
  PDPSectionType,
  ProductCatalogItemSearchSummaryFragment,
  ProductCatalogItemTilePresentationFragment,
  ProductCatalogPhotoAssetFragment,
  ProductCatalogVideoAssetFragment,
  ProductExternalOfferSummaryFragment,
  ProductExternalSummaryFragment,
  ProductUniversalItemSource,
} from '@graphql/generated';
import { MergedCatalogProductDetails } from './api/queries/getCatalogProductDetails';

export type MinimalCatalogCategory = {
  id: string;
  title: string;
  publicUrlPath: string;

  // Extended fields
  isCurationCategory?: boolean;
};

type MinimalCatalogCategoryWithLineage<Lineage> = MinimalCatalogCategory & {
  lineage?: Lineage;
  lineageCsp?: Lineage;
};

export type MinimalCatalogCategoryWithCsp =
  // Root
  | MinimalCatalogCategoryWithLineage<[]>
  // Department
  | MinimalCatalogCategoryWithLineage<[root: MinimalCatalogCategory]>
  // Category
  | MinimalCatalogCategoryWithLineage<[root: MinimalCatalogCategory, department: MinimalCatalogCategory]>
  // Subcategory
  | MinimalCatalogCategoryWithLineage<[root: MinimalCatalogCategory, department: MinimalCatalogCategory, category: MinimalCatalogCategory]>;

export type CatalogProductTileItem = Merge<
  NonNullable<NonNullable<GetAllCatalogProductGridItemsQuery['productCatalogSearchResults']['pagedResults']>['edges'][number]['node']['catalogItem']>,
  {
    tilePresentation?: ProductCatalogItemTilePresentationFragment;
    collectionDisplayInfos?: Array<
      Maybe<{
        displayInfoId: string;
        pdpSectionType?: PDPSectionType | null;
      }>
    >;
  }
>;
export const isCatalogItem = (item: UniversalItem): item is CatalogItemTile => {
  return 'itemType' in item;
};

export const isExternalProductOffer = (item: UniversalItem): item is ExternalProductOffer => {
  return 'productId' in item;
};

export type UniversalItem = ExternalProductOffer | CatalogItemTile;

export type ExternalProductOffer = ProductExternalOfferSummaryFragment;
export type ExternalProduct = ProductExternalSummaryFragment;

export type CatalogItemTile = Merge<
  Omit<ProductCatalogItemSearchSummaryFragment, '__typename'>,
  {
    source?: ProductUniversalItemSource;
    tilePresentation?: ProductCatalogItemTilePresentationFragment;
    collectionDisplayInfos?: Array<
      Maybe<{
        displayInfoId: string;
        pdpSectionType?: PDPSectionType | null;
      }>
    >;
  }
>;

export type CatalogProductItem = NonNullable<NonNullable<GetCurationCatalogProductsQuery['productCatalogSearchResults']['pagedResults']>['edges'][number]['node']['catalogItem']>;

export type CatalogProductListFilters = Array<NonNullable<NonNullable<GetAllCatalogProductGridItemsQuery['productCatalogSearchResults']['allFilters']>[number]>>;
export type CatalogProductListFilterAttribute = NonNullable<
  NonNullable<NonNullable<GetAllCatalogProductGridItemsQuery['productCatalogSearchResults']['allFilters']>[number]>['attributes'][number]
>;

export enum CatalogProductItemTags {
  joyExclusive = 'JoyExclusive',
}

export type CatalogProductItemDetails = NonNullable<MergedCatalogProductDetails>;
export type MinimalCatalogProductItemDetails = Merge<CatalogProductItemDetails, Partial<Pick<CatalogProductItemDetails, 'pdpSections' | 'subCategories' | 'parentCategories'>>>;
export type CatalogCollectionProductItemDetails = NonNullable<
  CatalogProductItemDetails & {
    group?:
      | Maybe<{
          groupDimensions: {
            title: string;
          }[];
        }>
      | undefined;
  }
>;

export type CatalogProductMediaAsset = ProductCatalogPhotoAssetFragment | ProductCatalogVideoAssetFragment;
